import React from 'react';
import TablePagination from '../components/TablePagination';
import { useTablePagination } from '../hooks/useTablePagination';
import MetricHeader from '../components/MetricHeader';

type NullableNumber = number | null;

interface QualityReportRow {
  date: string;
  meetingCount: number;
  qualityOkRate: number;
  avgQuality: string;
  loginSuccessRate: number;
  audioStutterRate: number;
  audioStutterCount: number;
  audioStutterOkRate: number;
  videoStutterRate: number;
  videoStutterCount: number;
  videoStutterOkRate: number;
  screenStutterRate: number;
  screenStutterCount: number;
  screenStutterOkRate: number;
  avgLatencyMs: number;
  networkOkRate: number;
  avgReconnectCount: number;
  reconnectOkRate: number;
}

const QualityReport: React.FC = () => {
  const avgAudioStutterDesc = '时间范围会议的卡顿率总和/会议次数（会议平均卡顿次数）';
  const avgVideoStutterDesc = '时间范围会议的卡顿率总和/会议次数（会议平均卡顿次数）';
  const avgScreenStutterDesc = '时间范围会议的卡顿率总和/会议次数（会议平均卡顿次数）';

  const tabs = ['最近7天', '最近30天', '本月', '上月', '本年', '自定义'];

  const rows: QualityReportRow[] = [
    {
      date: '25年1月15日',
      meetingCount: 76,
      qualityOkRate: 99.86,
      avgQuality: '好 (98)',
      loginSuccessRate: 99.86,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1.2,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1.2,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 560,
      networkOkRate: 98.32,
      avgReconnectCount: 1.2,
      reconnectOkRate: 98.32
    },
    {
      date: '25年1月14日',
      meetingCount: 55,
      qualityOkRate: 98,
      avgQuality: '好 (98)',
      loginSuccessRate: 98,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 580,
      networkOkRate: 98.32,
      avgReconnectCount: 0,
      reconnectOkRate: 98.32
    },
    {
      date: '25年1月13日',
      meetingCount: 44,
      qualityOkRate: 44,
      avgQuality: '好 (98)',
      loginSuccessRate: 44,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 580,
      networkOkRate: 98.32,
      avgReconnectCount: 2,
      reconnectOkRate: 98.32
    },
    {
      date: '25年1月12日',
      meetingCount: 33,
      qualityOkRate: 33,
      avgQuality: '中 (86)',
      loginSuccessRate: 33,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 580,
      networkOkRate: 98.32,
      avgReconnectCount: 3.5,
      reconnectOkRate: 98.32
    },
    {
      date: '25年1月11日',
      meetingCount: 44,
      qualityOkRate: 44,
      avgQuality: '好 (98)',
      loginSuccessRate: 44,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 580,
      networkOkRate: 98.32,
      avgReconnectCount: 1.2,
      reconnectOkRate: 98.32
    },
    {
      date: '25年1月10日',
      meetingCount: 55,
      qualityOkRate: 55,
      avgQuality: '好 (98)',
      loginSuccessRate: 55,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 580,
      networkOkRate: 98.32,
      avgReconnectCount: 1,
      reconnectOkRate: 98.32
    },
    {
      date: '25年1月9日',
      meetingCount: 12,
      qualityOkRate: 12,
      avgQuality: '好 (98)',
      loginSuccessRate: 12,
      audioStutterRate: 0.45,
      audioStutterCount: 1,
      audioStutterOkRate: 98.32,
      videoStutterRate: 0.45,
      videoStutterCount: 1,
      videoStutterOkRate: 98.32,
      screenStutterRate: 0.45,
      screenStutterCount: 1,
      screenStutterOkRate: 98.32,
      avgLatencyMs: 580,
      networkOkRate: 98.32,
      avgReconnectCount: 2,
      reconnectOkRate: 98.32
    }
  ];
  const {
    total,
    page,
    pageCount,
    pageSize,
    pagedRows,
    setPage,
    setPageSize
  } = useTablePagination(rows);

  const formatPercent = (value: NullableNumber) => {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`;
  };

  const formatCount = (value: NullableNumber) => {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? `${value}` : value.toFixed(1);
  };

  const renderRateWithCount = (rate: number, count: number) => (
    <span className="metric-cell">{`${rate.toFixed(2)}% (${formatCount(count)}次)`}</span>
  );

  return (
    <div className="page-block">
      <div className="breadcrumb">管理 &gt; 质量报告</div>
      <div className="page-card">
        <div className="tab-list">
          {tabs.map((tab, index) => (
            <button
              key={tab}
              type="button"
              className={`tab-button ${index === 0 ? 'active' : ''}`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="toolbar toolbar-bottom">
          <div className="toolbar-left">
            <select className="toolbar-select">
              <option>会议ID</option>
              <option>主题</option>
              <option>创建者</option>
            </select>
            <input className="toolbar-input" placeholder="请输入" />
            <button type="button" className="toolbar-icon" aria-label="搜索">
              <span className="icon icon-search" />
            </button>
            <button type="button" className="toolbar-icon" aria-label="刷新">
              <span className="icon icon-refresh" />
            </button>
          </div>
          <button type="button" className="toolbar-export">
            <span className="icon icon-download" />
          </button>
        </div>

        <div className="table-container">
          <table className="compact-table">
            <thead>
              <tr>
                <th>日期</th>
                <th>会议数</th>
                <th>质量正常会议占比</th>
                <th>平均整体质量</th>
                <th>5s登录成功率</th>
                <th>
                  <MetricHeader label="平均音频卡顿率（次数）" description={avgAudioStutterDesc} />
                </th>
                <th>音频卡顿正常占比</th>
                <th>
                  <MetricHeader label="平均视频卡顿率（次数）" description={avgVideoStutterDesc} />
                </th>
                <th>视频卡顿正常占比</th>
                <th>
                  <MetricHeader label="平均屏幕共享卡顿率（次数）" description={avgScreenStutterDesc} />
                </th>
                <th>屏幕卡顿正常占比</th>
                <th>网络平均延时</th>
                <th>网络正常占比</th>
                <th>平均重连次数</th>
                <th>重连正常占比</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map(row => (
                <tr key={row.date}>
                  <td>{row.date}</td>
                  <td>{row.meetingCount}</td>
                  <td className="metric-cell">{formatPercent(row.qualityOkRate)}</td>
                  <td>{row.avgQuality}</td>
                  <td className="metric-cell">{formatPercent(row.loginSuccessRate)}</td>
                  <td>{renderRateWithCount(row.audioStutterRate, row.audioStutterCount)}</td>
                  <td className="metric-cell">{formatPercent(row.audioStutterOkRate)}</td>
                  <td>{renderRateWithCount(row.videoStutterRate, row.videoStutterCount)}</td>
                  <td className="metric-cell">{formatPercent(row.videoStutterOkRate)}</td>
                  <td>{renderRateWithCount(row.screenStutterRate, row.screenStutterCount)}</td>
                  <td className="metric-cell">{formatPercent(row.screenStutterOkRate)}</td>
                  <td className="metric-cell">{row.avgLatencyMs}ms</td>
                  <td className="metric-cell">{formatPercent(row.networkOkRate)}</td>
                  <td className="metric-cell">{formatCount(row.avgReconnectCount)}</td>
                  <td className="metric-cell">{formatPercent(row.reconnectOkRate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <TablePagination
          total={total}
          page={page}
          pageCount={pageCount}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
        />
      </div>
    </div>
  );
};

export default QualityReport;
